import * as Yup from 'yup';

export const automatedReviewLogsFiltersSchema = () =>
  Yup.object({
    lead: Yup.array().nullable(),
    channel: Yup.string().nullable(),
    propertyUid: Yup.string().nullable(),
    status: Yup.string().nullable(),
  });

export type AutomatedReviewLogsFiltersSchemaType = Yup.InferType<
  ReturnType<typeof automatedReviewLogsFiltersSchema>
>;

export const getFormDefaultValues =
  (): AutomatedReviewLogsFiltersSchemaType => {
    return {
      lead: [],
      channel: '',
      propertyUid: '',
      status: '',
    };
  };
